import {PATIENTS_ROUTE} from "../../../routes";
import {useNavigate} from "react-router";
import {useEffect} from "react";
import {clearSavedListParams} from "../../../helpers/LocalStorageHelper";

export function PatientsClear() {
    const history = useNavigate()
    useEffect(() => {
        clearSavedListParams();
        history(PATIENTS_ROUTE, {replace: true});
    }, []);
    return <div/>
}